goog.provide('el8.ext.onboarding.accountForm');

goog.require('el8.ext.Form');
goog.require('el8.template.ext.onboarding.accountForm');
goog.require('el8.service.urls');
goog.require('el8.ext.onboarding.signupData');
goog.require('el8.ext.util');
goog.require('el8.util.consts');
goog.require('el8.ext.onboarding.ButtonSet');
goog.require('el8.uiwidget.NewPasswordFields');
goog.require('el8.ext.onboarding.challengeQs');


el8.ext.onboarding.accountForm.init = function(spec) {

    var formGuide = spec.formGuide;
    var formName = spec.name;

    var $container = spec.container.find('.form-guide-container');
    $container.html(el8.template.ext.onboarding.accountForm.content({
        challengeQs: el8.ext.onboarding.challengeQs
    }));

    var $form = $('form', $container);

    var validationOpts = el8.ext.util.validationOpts();

    var that = new el8.ext.Form({
        container: $form,
        name: formName,
        buttonElt: spec.container.find('.form-guide-buttons'),
        buttonSetConstructor: el8.ext.onboarding.ButtonSet,
        validationOpts: validationOpts,
        fields: [
            {
                name: 'email',
                selector: ':input[name="email"]',
                infoText: 'e.g. abc@xyz.com...',
                size: 'large',
                maxLength: 75,
                validate: {
                    required: true,
                    email: true,
                    remote: {
                        url: el8.service.urls.get('validEmail'),
                        type: 'GET'
                    }
                },
                validateMsgs: {
                    required: 'Required Field',
                    remote: 'Email Already Taken'
                }
            },
            {
                name: 'password1',
                selector: ':input[name="password1"]',
                infoText: 'Your password...',
                size: 'large',
                maxLength: 20,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'password2',
                selector: ':input[name="password2"]',
                infoText: 'Your password again...',
                size: 'large',
                maxLength: 20,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'challenge1',
                selector: ':input[name="challenge1"]',
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'challengeAnswer1',
                selector: ':input[name="challengeAnswer1"]',
                size: 'large',
                infoText: 'Answer to Challenge Question 1...',
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'challenge2',
                selector: ':input[name="challenge2"]',
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'challengeAnswer2',
                selector: ':input[name="challengeAnswer2"]',
                size: 'large',
                infoText: 'Answer to Challenge Question 2...',
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
           },
            {
                name: 'challenge3',
                selector: ':input[name="challenge3"]',
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'challengeAnswer3',
                selector: ':input[name="challengeAnswer3"]',
                size: 'large',
                infoText: 'Answer to Challenge Question 3...',
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            }
        ]
    });
    that.addButton('done', 'Done', function(_form, $btn) {
        if (that.isValid()) {
            $btn.prop('disabled', true);
            var mapped = {};
            mapped['email'] = that.getVal('email');
            mapped['password'] = that.getVal('password1');
            mapped['user_agrees_to_eula'] = true;
            mapped['challenge1_q'] = that.getVal('challenge1');
            mapped['challenge1_answer'] = that.getVal('challengeAnswer1');
            mapped['challenge2_q'] = that.getVal('challenge2');
            mapped['challenge2_answer'] = that.getVal('challengeAnswer2');
            mapped['challenge3_q'] = that.getVal('challenge3');
            mapped['challenge3_answer'] = that.getVal('challengeAnswer3');
            mapped['complete'] = true;
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('signup', [el8.ext.onboarding.signupData.getId()]),
                data: {data: JSON.stringify(mapped)},
                success: function(data) {
                    window.location.href = el8.service.urls.get('signupComplete');
                },
                error: function() {
                    formGuide.showErrorPage();
                }
            });
        }
    }, true);
    that.addButton('back', 'Back', function(_form) {
        formGuide.prev(formName);
    }, false);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        (new el8.uiwidget.NewPasswordFields({
            field1: $(':input[name="password1"]', $container),
            selectorFn1: function($elt) { return $elt.prevAll('.error-msg'); },
            field2: $(':input[name="password2"]', $container),
            selectorFn2: function($elt) { return $elt.prevAll('.error-msg'); }
        })).init();
        $container.on('change', ':input[data-type="challengeQ"]',  function(e) {
            var name = $(this).attr('name');
            that._dedupChallengeQs(name);
        });
    };

    var super_render = that.render;
    that.render = function() {
        super_render.call(that);
        _gaq.push(['_trackPageview', el8Globals['OB']+'page-account/show/']);
    };

    var super_isValid = that.isValid;
    that.isValid = function() {
        return super_isValid.call(that) && !$('.has-error', $container).length;
    };

    /**
     * Managing the challenge questions
     */
    that._dedupChallengeQs = function(selectedName) {
        var usedChallengeQs = (function() {
            var qs = [];
            if (that.getVal('challenge1')) {
                qs.push(that.getVal('challenge1'));
            }
            if (that.getVal('challenge2')) {
                qs.push(that.getVal('challenge2'));
            }
            if (that.getVal('challenge3')) {
                qs.push(that.getVal('challenge3'));
            }
            return qs;
        })();
        var eligibleQs = el8.ext.onboarding.challengeQs.filter(function(q) {
            return !usedChallengeQs.has(q);
        });
        var updateQs = function(name) {
            var $elt = that.getInputField(name);
            var currVal = that.getVal(name);
            var challengeQList = eligibleQs.slice(0); // make copy
            if (currVal && !challengeQList.has(currVal)) {
                challengeQList.push(currVal);
            }
            $elt.html(
                el8.template.ext.onboarding.accountForm.challengeQList({
                    challengeQs: challengeQList,
                    num: name[name.length-1]*1 // relies on form of name str
                })
            );
            if (currVal) {
                that.setVal(name, currVal, true); // no trigger
            }
        };
        ['challenge1', 'challenge2', 'challenge3'].map(function(a) {
            if (a !== selectedName) {
                updateQs(a);
            }
        });
    };

    return that;

};
